const { desktopCleverTapEvent } = require("../../tracking");
const { CLEVERTAP_EVENT_MAP } = require("../../tracking/au.desktop-clevertap");

export const EW_SKIPPED_ENTRY_POINTS = {
    "PRE_BC": "Pre BC",
    "ORDER_SUMMARY_VAS_GIFT": "Order summary VAS gift",
    "POST_BC_ADD_ON": "Post BC add on",
    "POST_BC_NUDGE": "Post BC nudge",
    "CDP": "CDP"
};

export const EW_NOT_ADDED_KEYS = {
    "CAR_HUB": "Car hub",
    "CAR_NAME": "Car name",
    "EW_CATEGORY": "EW category",
    "ENTRY_POINT": "Entry point",
    "USER_EMAIL": "User Email",
    "USER_NAME": "User name",
    "DISCOUNT_OFFERED": "Discount offered",
    "DISCOUNT_OFFERED_PRODUCT_NAME": "Discount offered product name",
    "UTM_SOURCE": "utm_source",
    "UTM_MEDIUM": "utm_medium",
    "UTM_CAMPAIGN": "utm_campaign",
    "DEEP_LINK_URL": "Deeplink URL"
};

const ewSkippedCTEvent = (data) => {
    desktopCleverTapEvent(CLEVERTAP_EVENT_MAP.EW_NOT_ADDED, data);
};
export default ewSkippedCTEvent;
